import { IAnchorNavigation } from '../../models/interfaces/IAnchorNavigation';
import { AnchorNavigationAction, SET_ANACHOR_NAVIGATION } from '../actionTypes/anchorNavigationTypes';

export const setAnchorNavigation = (action: IAnchorNavigation[]): AnchorNavigationAction => {
    return {
        type: SET_ANACHOR_NAVIGATION,
        payload: action
    };
};
